import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const NAV_LINKS = [
  { href: "/#coaches", label: "Coaches" },
  { href: "/#programmes", label: "Programmes" },
  { href: "/#pricing", label: "Pricing" },
  { href: "/#faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  const linkResolve = (href) => (isHome ? href : `/${href.startsWith("/#") ? href.slice(1) : href}`);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 w-full backdrop-blur-xl bg-white/80 border-b border-slate-200/80"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-slate-950 text-white grid place-items-center font-display font-black">
            G
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold tracking-tight text-slate-950 text-base">
              Grant Football
            </div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-semibold">
              1-1 Coaching
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={linkResolve(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="px-4 py-2 text-sm font-semibold text-slate-700 hover:text-slate-950 rounded-full hover:bg-slate-100 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link to="/book" className="hidden md:block">
            <Button
              data-testid="navbar-book-btn"
              className="rounded-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-5 font-semibold shadow-soft"
            >
              Book a Session
            </Button>
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 rounded-xl border border-slate-200"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={linkResolve(l.href)}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className="px-3 py-3 text-base font-semibold text-slate-800 rounded-lg hover:bg-slate-100"
              >
                {l.label}
              </a>
            ))}
            <Link to="/book" onClick={() => setOpen(false)} className="mt-2">
              <Button
                data-testid="mobile-book-btn"
                className="w-full rounded-full bg-blue-600 hover:bg-blue-700 text-white py-5"
              >
                Book a Session
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
